export default __webpack_public_path__ + "static/media/TeamsAssets-Light.6d0fa9a8.woff";